import { useEffect } from 'react';
import {Link} from "react-router-dom";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import protegida_icono from "../../../../assets/vw/svg/candado-cerrado.svg";
import no_protegida_icono from "../../../../assets/vw/svg/candado-abierto.svg";
import soporte_icono from "../../../../assets/vw/svg/soporte.svg";
import archivar from "../../../../assets/vw/svg/archivar.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import unarchive from "../../../../assets/vw/svg/unarchive.svg";

const CardContenido = ({ infoCard, handleArchivar, editar, archivo, rowDesarchivar, setShowContent })  => {

    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])

    return (
        <>
            <div className={"select-card-content mb-4"}>
                <div className="select-card-content-title" style={{ marginTop: '20px' }}>URL:</div>
                <div className="select-card-content-description mb-1">
                    {infoCard.original.url ? infoCard.original.url : "-"}
                </div>
                <div className="pt-2 select-card-content-title">Path:</div>
                <div className="select-card-content-description">
                    {infoCard.original.path ? infoCard.original.path : "-"}
                </div>
            </div>
            <div className="select-card-footer d-flex justify-content-between">
                <div className={""}>
                    {
                        archivo ? (
                            <img src={inactivo_icono} className={"mr-2"} style={{ padding: '5px 5px 5px 0' }} alt="activo"></img>
                        ) : (
                            <img className={"mr-2"} style={{ padding: '5px 5px 5px 0' }} src={activo_icono} alt="activo"></img>
                        )
                    }

                    {infoCard.original.protegida === 1 ? (
                        <img src={protegida_icono} className="ps-2 mr-2" alt="protegida"></img>
                    ) : (
                        <img src={no_protegida_icono} className="ps-2 mr-2" alt="noprotegida"></img>
                    )}

                    {infoCard.original.pathSoporte &&
                        infoCard.original.pathSoporte !== "" ? (
                        <Link to={infoCard.original.pathSoporte}>
                            <img src={soporte_icono} className="ps-2" alt="soporte" data-track-click="link-soporte"></img>
                        </Link>
                    ) : (
                        ""
                    )}
                </div>
                <div className={"d-flex align-items-end"}>
                    {
                        archivo ? (
                            <button
                                className="button_icon-vw btn-desarchivar"
                                type="button"
                                onClick={() => rowDesarchivar({ row: infoCard })}
                            >
                                <div className="aling-icon-desarchivar font-azul-claro-complementario">
                                    {" "}
                                    <img
                                        src={unarchive}
                                        alt="unarchive"
                                        className="px-1"
                                    ></img>{" "}
                                    Desarchivar
                                </div>
                            </button>
                        ) : (
                            <>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => editar({ row: infoCard })}
                                >
                                    <div className="d-flex font-azul-claro-secundario">
                                        <div className={"editar-icon-mobile mr-2"}></div>
                                        Editar
                                    </div>
                                </button>
                                <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar({ row: infoCard })}
                                >
                                    <div className="d-flex font-amarillo-complementario">
                                        {" "}
                                        <img
                                            src={archivar}
                                            alt="archivar"
                                            className="px-2"
                                        ></img>{" "}
                                        Archivar
                                    </div>
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default CardContenido;
